var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.recipe)?_c('router-view',{key:_vm.$route.fullPath,attrs:{"recipe":_vm.recipe}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }